import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "paginationWrapper" }
const _hoisted_2 = { class: "prev" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  width: "7",
  height: "13",
  viewBox: "0 0 7 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 11.5L1 6.5L6 1.5",
    stroke: "#171717",
    "stroke-width": "1.67",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " Previous ", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "pagination" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "...")
], -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "...")
], -1)
const _hoisted_11 = { class: "next" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  width: "7",
  height: "13",
  viewBox: "0 0 7 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1.5L6 6.5L1 11.5",
    stroke: "#2D3232",
    "stroke-width": "1.67",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        disabled: _ctx.currentActivePage === 1,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(_ctx.currentActivePage - 1)))
      }, _hoisted_6, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", null, [
        (_ctx.numbersToRender.length > 0 && _ctx.numbersToRender[0] > 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(1)))
                }, "1")
              ]),
              _hoisted_8
            ], 64))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numbersToRender, (pageNum) => {
          return (_openBlock(), _createElementBlock("li", { key: pageNum }, [
            _createElementVNode("button", {
              class: _normalizeClass(_ctx.currentActivePage === pageNum && 'active'),
              onClick: ($event: any) => (_ctx.goToPage(pageNum))
            }, _toDisplayString(pageNum), 11, _hoisted_9)
          ]))
        }), 128)),
        (
            _ctx.numbersToRender.length > 0 &&
              _ctx.numbersToRender[_ctx.numbersToRender.length - 1] < _ctx.totalPages
          )
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_10,
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(_ctx.totalPages)))
                }, _toDisplayString(_ctx.totalPages), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        disabled: _ctx.currentActivePage === _ctx.totalPages,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.currentActivePage + 1)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Web.Containers.Next")), 1),
        _hoisted_13
      ], 8, _hoisted_12)
    ])
  ]))
}